import { toggleArray } from '@domain-group/javascript-utils'

import { useSetState } from '@domain-group/react-hooks'

import useSelector from '@hooks/useSelector'

import type { UserModel } from '@models/types'

const defaultState = {
  filterString: '',
  message: '',
  selectedUsers: [],
}

type SetState = (state: Partial<typeof defaultState>) => void

type ToggleSelectedUserParams = {
  selectedUsers: UserModel[],
  setState: SetState,
  user: UserModel,
}

const toggleSelectedUser = (params: ToggleSelectedUserParams) => {
  const { selectedUsers, setState, user } = params

  const updatedSelectedUsers = toggleArray(selectedUsers, user, { deepCompare: true })
  // @ts-expect-error TS2322
  setState({ selectedUsers: updatedSelectedUsers })
}

const useSelectSMSRecipientModal = () => {
  const [state, setState] = useSetState(defaultState)
  const {
    filterString, message, selectedUsers,
  } = state

  const images = useSelector(reduxState => reduxState.entities.images)

  const hasSelectedUsers = !!selectedUsers.length

  return {
    callbacks: {
      setModalState: (values: Partial<typeof defaultState>) => setState(values),
      toggleUser: (user: UserModel) => toggleSelectedUser({ selectedUsers, setState, user }),
    },
    filterString,
    hasSelectedUsers,
    images,
    message,
    selectedUsers,
  }
}

export type UseSelectSMSRecipientModalPayload = ReturnType<typeof useSelectSMSRecipientModal>

export default useSelectSMSRecipientModal
